import clsx from "classnames";
import { useLocale } from "@/hooks/useLocale";
import { placeholders } from "@/data/placeholders";
import classes from "./styles.module.scss";
import Image from "@/ui/Image";

export default function Host({ className, item }) {
  const locale = useLocale();

  return (
    <div className={clsx(className, classes.host)}>
      <figure className={classes.host__image}>
        {item.photo ? (
          <Image img={{ src: item.photo }} size="140x140" alt={item.name} className="w-100" />
        ) : (
          <Image
            img={{ path: "component.host.photo.fallback", src: "/assets/events/host/fallback.png" }}
            size="140x140"
            alt=""
            className="w-100"
          />
        )}
      </figure>
      <div className={classes.host__details}>
        <dl>
          <dt className="visually-hidden">Host</dt>
          <dd>{`${placeholders[`page.event.hosted.${locale}`]} ${item.name}`}</dd>
        </dl>
        <dl>
          <dt className="visually-hidden">Email</dt>
          <dd>
            <a href={`mailto:${item.email}`}>{item.email}</a>
          </dd>
        </dl>
      </div>
    </div>
  );
}
